import ProductLabel from 'apps/products/models/ProductLabel';
import ProductWarnings from 'apps/products/models/ProductWarnings';

const isOutOfStock = (product) => product && product.labels && product.labels.includes(ProductLabel.OOS);

export default function getWarningLabel(basketItem, product, productWarningsForSku) {
  if (productWarningsForSku.includes(ProductWarnings.QUANTITY_PER_ITEM_EXCEEDED)) {
    return 'Max. quantity exceeded';
  }

  if (basketItem && basketItem.quantity && isOutOfStock(product)) {
    return 'No more stock available';
  }

  return null;
}
